import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { FormLabel } from '@material-ui/core';
import Fab from "@material-ui/core/Fab";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";

import Link from '@material-ui/core/Link';
import axios from "axios/index";
// import {
//   signup_api,
//   domain,
//   instance_type,
//   chatbot_api_host,
// } from "../../../../config";
import {
  signup_api,
  domain,
  instance_type,
  chatbot_api_host,
} from "../../../../configtest";

import Icon from "@material-ui/core/Icon";
import { Input } from '@material-ui/core';
import { Style } from '@material-ui/icons';
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),

    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '300px',
    },
    '& .MuiButtonBase-root': {
      margin: theme.spacing(2),
    },
  },
  input: {
    display: "none"
  },
}));

const SignupForm = ({ handleClose }) => {
  const classes = useStyles();
  // create state variables for each input
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [selectedFile, setselectedFile] = useState({filename:null, status:0, image:null});
  const [responseMessage, setResponseMessage] = useState({message:null, type: null})
  let filename= "";

  
  const handleUploadClick = event => {   
    var file = event.target.files[0];

    if (file.size > 2 * 100000) {
      // fileSize > 5MB then show popup message
      alert(
        `File size is too large, please upload image of size less than 200kb.\nSelected File Size: ${
          file.size / 1000000
        }MB only`
      );
      return;
    }


    filename = file.name 
    const reader = new FileReader();
    // var url = reader.readAsDataURL(file); 
    reader.onloadend = function(e) {    
      setselectedFile({filename:filename, image:reader.result, status:2})
    }   
  };

  // VALUES ('${req.body.user.}', '${req.body.user.}', '${req.body.user.}', '${req.body.user.}', '${req.body.user.}',
  // '${req.body.user.designation}', ARRAY['BOTAIML']);, '${fileStatus.path}'`;



  const signUp = async ()=>{
    return new Promise(  (resolve, reject)=>{
        axios.post(signup_api, {user:{
          fname:firstName,
          lname:firstName,
          username:email,
          password:password,
          user_type:'admin',  
          picture:{fileName:selectedFile.filename ,data: selectedFile.image},
          domain: domain,
          instance_type: instance_type,
        }  
      },
      {withCredentials: true})
      .then( function (res) {
        resolve(res.data)
      })
      .catch(err=>{
        if(err && err.response && err.response.data && err.response.data.error) 
        reject(err.response.data.error)
        else  reject(err.message)})
    })
  }


  const handleSubmit = async e => {
    e.preventDefault();
    console.log(firstName, lastName, email, password, selectedFile);
    await signUp().then(res=>{
      // debugger;
      handleClose();
    }).catch(err=>{
      // debugger;
      setResponseMessage({message:err? err : 'Unable to SingnUp', type:'error'})})   
  };

  return (
    <form className={classes.root} onSubmit={handleSubmit}>
      <TextField
        label="First Name"
        variant="filled"
        required
        value={firstName}
        onChange={e => setFirstName(e.target.value)}
      />
      <TextField
        label="Last Name"
        variant="filled"
        required
        value={lastName}
        onChange={e => setLastName(e.target.value)}
      />
      <TextField
        label="Email"
        variant="filled"
        type="email"
        required
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
      <TextField
        label="Password"
        variant="filled"
        type="password"
        required
        value={password}
        onChange={e => setPassword(e.target.value)}
      />

 <Input  
 required
 id="contained-button-file"
 type='file'
 accept="image/*" 
 onChange={(e)=>handleUploadClick(e)}
 className={classes.input} 
 /> 

<label htmlFor="contained-button-file">
              <Fab component="span" className={classes.button}>
                <AddPhotoAlternateIcon />
              </Fab>
              {selectedFile.status ==0 && <span>Select Your recent Photo (png/jpg)</span>}
              {selectedFile.status ==2 && <span>{selectedFile.filename}</span>}
            </label>


{/*       
<FormLabel>Select a profile Pgoto</FormLabel> */}

      <div>
      <Link href="#" onClick={(e)=>{e.preventDefault(); handleClose()}} variant="body2">
      Already have an account?
      </Link>

       
        <Button  type="submit" variant="contained" color="primary">
          Signup
        </Button>
      </div>

      <div>
        {responseMessage.type == 'error' && <p>{responseMessage.message}</p>}
      </div>
    </form>
  );
};

export default SignupForm;